import { render, staticRenderFns } from "./qualifications.vue?vue&type=template&id=28953c69&"
import script from "./qualifications.vue?vue&type=script&lang=js&"
export * from "./qualifications.vue?vue&type=script&lang=js&"
import style0 from "./qualifications.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports